import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Home/Navbar';
import Hero from './Home/Hero';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Projects from './Home/Projects';
import Footer from './Home/Footer';
import ContactSection from './Home/Contact';
import ChangeMakersSection from './Home/ChangeMakers';
import Partners from './Home/Partners';
import Story from './Home/Story';
import Solutions from './Home/Solutions';
import Farmsoft from './Home/Farmsoft';
import HowItWorks from './Home/HowItWorks';
import Economics from './Home/Economics';
import RiskManaged from './Home/RiskManaged';
import FAQ from './Home/FAQ';
import GoingForward from './Home/GoingForward';
import WhyMatters from './Home/WhyMatters';
import ScrollToTopButton from './Home/ScrollToTop';
import Preloader from './Home/PreLoader';
import ProjectGallery from './Home/Gallery';

const App = () => {
  const location = useLocation();

  const shouldHideNavbar = location.pathname.startsWith('/gallery');

  return (
    <>
      <Preloader />
      {!shouldHideNavbar && <Navbar />}

      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Solutions />
            <Farmsoft />
            <HowItWorks />
            <Economics />
            <Story />
            <GoingForward />
            <RiskManaged />
            <WhyMatters />
            <Projects />
            <FAQ />
            <Partners />
            <ChangeMakersSection />
            <ContactSection />
            <Footer />
            <ScrollToTopButton />
          </>
        } />

        <Route path="/projects" element={<Projects />} />
        <Route path="/gallery/:projectId" element={<ProjectGallery />} />
      </Routes>
    </>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
